import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, combineReducers } from "redux";
import Thunk from "redux-thunk";
import "./styles/index.scss";
import reducers from "./external/reducers";
import Login from "./pages/login";
import Availability from "./pages/availability";
import Checkout from "./pages/checkout";
import Notifications from "./pages/notifications";
import BulkBooking from "./pages/bulkBooking";
import Search from "./pages/search";
import Dashboard from "./pages/dashboard";
import Pricing from "./pages/pricing";
import Reports from "./pages/reports";
import CacheBuster from "react-cache-buster";
import { version } from "../package.json";

import Loader from "./components/loader";
import QRScanner from "./pages/qr-scan";
import Event from "./pages/event";

let preLoadedState = {};
if (typeof window !== "undefined") {
  preLoadedState = window.__PRELOADED_STATE__;
  delete window.__PRELOADED_STATE__;
}

const rootReducer = combineReducers(reducers);
const store = createStore(rootReducer, preLoadedState, applyMiddleware(Thunk));
const isProduction = process.env.REACT_APP_BASE_URL ? true : false;
console.log({ isProduction });
ReactDOM.render(
  <CacheBuster
    currentVersion={version}
    isEnabled={isProduction} //If false, the library is disabled.
    isVerboseMode={true} //If true, the library writes verbose logs to console.
    loadingComponent={<Loader />} //If not pass, nothing appears at the time of new version check.
  >
    <Router>
      <Provider store={store}>
        <Switch>
          <Route exact path={"/login"} component={Login} />
          <Route exact path={"/dashboard"} component={Dashboard} />
          <Route exact path={"/"} component={Availability} />
          <Route exact path={"/checkout"} component={Checkout} />
          <Route exact path={"/notifications"} component={Notifications} />
          <Route exact path={"/bulk-booking"} component={BulkBooking} />
          <Route exact path={"/search"} component={Search} />
          <Route exact path={"/pricing"} component={Pricing} />
          <Route exact path={"/reports"} component={Reports} />
          <Route exact path={"/events"} component={Event} />
          <Route exact path={"/scan-qr"} component={QRScanner} />
        </Switch>
      </Provider>
    </Router>
  </CacheBuster>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
